import ApiClient from './api.es6';
import UrlUtils from '../common/util/url.es6';
import OslUtils from '../common/util/os.es6';

export default class ScheduleList {

    constructor(){
        this.today = new Date();

        this.currentMonth = '';
        this.currentYear = '';

        this.calendarTerm = {
            start: {
                year: 2024,
                month: 8,
            },
            end: {
                year: 2025,
                month: 12,
            },
        };

        this.items = [];
        this.query = {};

        this.contents = document.querySelector('.l-contents');
        this.calendar = document.querySelector('.js-calendar');

        this.init();
    }

    init() {
        this.query = UrlUtils.getQuery();
        this.os = OslUtils.getMobileOS();

        this.today = this.query.y && this.query.m ? this.setToday() : this.today;
        this.api = new ApiClient('../api/schedule.php');
        this.loadJson();
        this.pagenateCalendar();
    }

    async loadJson() {
        try {
            const json = await this.api.fetchData();
            this.parseJson(json);
            this.sortDataMonthList();
            this.getCurrentDate(this.today);
            this.createListHTML(this.currentMonth, this.currentYear);
        } catch (e) {
            console.error('Failed to fetch data:', e);
        }
    }

    setToday() {
        const { y: year, m: month } = this.query;

        const paramDate = new Date(year, month - 1);
        const startDate = new Date(this.calendarTerm.start.year, this.calendarTerm.start.month - 1);
        const endDate = new Date(this.calendarTerm.end.year, this.calendarTerm.end.month - 1);

        return paramDate >= startDate && paramDate <= endDate ? paramDate : this.today;
    }

    parseJson(json) {
        console.log(json);

        for (let i = 0; i < json.length; i++) {
            const data = {};
            data.id = json[i].id;
            data.title = json[i].title_html;
            data.date = this.os === 'iOS' ? json[i].date : json[i].date.replace(/-/g, '.');
            data.isNew = parseInt(json[i].newflg);
            data.content = json[i].content_html;

            const tagRegex = /#tag:([a-zA-Z0-9,]+)/;
            const match = data.content.match(tagRegex);
            if (match) {
                data.tags = match[1].split(',').map((t) => t.trim()); // タグを配列に分解
                data.content = data.content.replace(tagRegex, ''); // タグを本文から削除
            } else {
                data.tags = [];
            }

            this.items.push(data);
        }
    }

    getCurrentDate(today) {
        this.currentMonth = today.getMonth() + 1;
        this.currentYear = today.getFullYear();

        this.setCurrentMonthCalendar(this.currentMonth, this.currentYear);
    }

    setCurrentMonthCalendar(currentMonth, currentYear) {
        const currentMonthEn = this.getMonthName(currentYear, currentMonth);
        this.contents.setAttribute('data-month', currentMonth);

        this.setCurrentCalendarHead(currentMonth, currentMonthEn, currentYear);
        this.createCalendar(currentMonth, currentYear);
        this.pagenateBtnDisable(currentMonth, currentYear);
    }

    getMonthName(year, month) {
        const options = { month: 'long' };
        const date = new Date(year, month - 1); // 月は0ベースで指定します
        return new Intl.DateTimeFormat('en', options).format(date);
    }

    createCalendar(currentMonth, currentYear) {
        this.calendarCont = this.calendar.querySelector('.js-calendar-cont');

        const weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        const startDate = new Date(currentYear, currentMonth - 1, 1); // 月の最初の日を取得
        const endDate = new Date(currentYear, currentMonth, 0); // 月の最後の日を取得

        const endDayCount = endDate.getDate(); // 月の末日
        const startDay = startDate.getDay(); // 月の最初の日の曜日を取得
        let dayCount = 1; // 日にちのカウント
        let calendarHtml = ''; // HTMLを組み立てる変数

        calendarHtml += '<tr>';
        for (let i = 0; i < weeks.length; i++) {
            calendarHtml += `<th scope="col">` + weeks[i] + '</th>';
        }
        calendarHtml += '</tr>';

        for (let w = 0; w < 6; w++) {
            calendarHtml += '<tr>';

            for (let d = 0; d < 7; d++) {
                if (w == 0 && d < startDay) {
                    // 1行目で1日の曜日の前
                    calendarHtml += '<td></td>';
                } else if (dayCount > endDayCount) {
                    // 末尾の日数を超えた
                    calendarHtml += '<td></td>';
                } else {
                    const dayList = this.specifiedDateArray(dayCount, currentMonth, currentYear);

                    if (dayList && dayList.length !== 0) {
                        const listId = dayList[0];
                        calendarHtml += `<td class="-active"><a href="#${listId.id}">${dayCount}</a></td>`;
                    } else {
                        calendarHtml += '<td>' + dayCount + '</td>';
                    }

                    dayCount++;
                }
            }
            calendarHtml += '</tr>';
        }

        this.calendarCont.innerHTML = calendarHtml;
    }

    specifiedDateArray(date, currentMonth, currentYear) {
        const listName = `list${currentYear}${String(currentMonth).padStart(2, '0')}`;

        if (this.lists[listName]) {
            return this.lists[listName].filter((listitem) => {
                const ListDate = new Date(listitem.date);
                const itemDate = ListDate.getDate();

                return itemDate === date;
            });
        } else {
            return;
        }
    }

    setCurrentCalendarHead(currentMonth, currentMonthEn, currentYear) {
        this.currentCalendarMonthNum = this.calendar.querySelector('.js-calendar-month-num');
        this.currentCalendarMonthEn = this.calendar.querySelector('.js-calendar-month-en');
        this.currentCalendarYear = this.calendar.querySelector('.js-calendar-month-year');

        this.currentCalendarMonthNum.innerHTML = currentMonth;
        this.currentCalendarMonthEn.innerHTML = currentMonthEn;
        this.currentCalendarYear.innerHTML = currentYear;
    }

    pagenateCalendar() {
        this.pagenateprev = this.calendar.querySelector('.js-calendar-pagenate-prev');
        this.pagenatenext = this.calendar.querySelector('.js-calendar-pagenate-next');

        this.pagenateprev.addEventListener('click', () => {
            if (this.currentMonth === 1) {
                this.currentMonth = 12;
                this.currentYear--;
            } else {
                this.currentMonth--;
            }

            this.updateCalendar(this.currentMonth, this.currentYear);
        });

        this.pagenatenext.addEventListener('click', () => {
            if (this.currentMonth === 12) {
                this.currentMonth = 1;
                this.currentYear++;
            } else {
                this.currentMonth++;
            }

            this.updateCalendar(this.currentMonth, this.currentYear);
        });
    }

    updateCalendar() {
        this.setCurrentMonthCalendar(this.currentMonth, this.currentYear);
        this.createListHTML(this.currentMonth, this.currentYear);
        this.pagenateBtnDisable(this.currentMonth, this.currentYear);
        this.pageReloadParamDate(this.currentMonth, this.currentYear);
    }

    pagenateBtnDisable(currentMonth, currentYear) {
        const isStartMonth = currentMonth === this.calendarTerm.start.month && currentYear === this.calendarTerm.start.year;
        const isEndMonth = currentMonth === this.calendarTerm.end.month && currentYear === this.calendarTerm.end.year;

        this.pagenateprev.classList.toggle('-disable', isStartMonth);
        this.pagenatenext.classList.toggle('-disable', isEndMonth);
    }

    sortDataMonthList() {
        this.lists = {};

        this.items.forEach((listitem) => {
            const date = new Date(listitem.date);
            const year = Number(date.getFullYear());
            const month = Number(date.getMonth() + 1); // 月は0ベースなので1を加える
            const listName = `list${year}${String(month).padStart(2, '0')}`;

            if (!this.lists[listName]) {
                this.lists[listName] = this.sortDataByYearAndMonth(year, month);
            }
        });
        //console.log(this.lists);
    }

    sortDataByYearAndMonth(year, month) {
        return this.items.filter((listitem) => {
            const date = new Date(listitem.date);
            const itemYear = date.getFullYear();
            const itemMonth = date.getMonth() + 1; // 月は0ベースなので1を加える

            return itemYear === year && itemMonth === month;
        });
    }

    createListHTML(currentMonth, currentYear) {
        const scheduleList = document.querySelector('.js-schedule-list');
        const listName = `list${currentYear}${String(currentMonth).padStart(2, '0')}`;

        const currentMonthlists = this.lists[listName];
        let htmlstr = '';

        if (!currentMonthlists) {
            htmlstr += `coming soon`;
            scheduleList.innerHTML = htmlstr;
        } else {
            const devStr = this.query.dev === '1' ? '&dev=1' : '';

            for (let i = 0; i < currentMonthlists.length; i++) {
                const item = currentMonthlists[i];
                const newClass = item.isNew ? ' -new' : '';
                const date = item.date.replace(/-/g, '.');

                htmlstr += `
                <li class="schedule-list__item ${newClass}" id=${item.id}>
                    <a href="./detail.html?id=${item.id + devStr}" class="c-hover_op">
                        <div class="head c-grotesk">
                            <p class="date">${date}</p>
                            <p class="category" data-tag="${item.tags}">${item.tags}</p>
                            </div>
                        <div class="ttl">${item.title}</div>
                    </a>
                </li>`;
            }

            scheduleList.innerHTML = htmlstr;
        }
    }

    pageReloadParamDate(month, year) {
        const currentUrl = new URL(window.location.href);

        currentUrl.searchParams.set('y', year);
        currentUrl.searchParams.set('m', month);

        window.history.pushState({}, '', currentUrl);
    }
}
